<food-insecurity>

  <hero-block
    heading1="TOGETHER, WE CAN"
    heading2="END WORLD HUNGER"
    heading3="Today, upwards of 828 million people around the world experience hunger–that’s more than one in ten of us. Despite growing global food demand and the increasing risks posed by conflict, climate, and economic shocks, we believe that with strong community support, farmers, ranchers, and food banking organizations can be better prepared to meet the challenge of hunger today and tomorrow. Together with them, John Deere is committed to creating a world in which no one goes hungry and where every person has access to safe, nutritious, and sufficient food."
    imgurl="../../../public/images/img_hero_tractor.jpg"
    imgurlmobile="../../../public/images/img_hero_tractor_mobile.jpg"
    imgurltablet="../../../public/images/img_hero_tractor_tablet.jpg"
  />

  <div class="v-divider-block">
    <div class="left-dots">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201.7 245.01">
        <circle fill="#FFFFFF" cx="5.27" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="44.22" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="83.17" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="122.13" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="161.08" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="200.03" r="5.27"/>
        <circle fill="#FFFFFF" cx="5.27" cy="238.98" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="238.98" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="238.98" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="238.98" r="5.27"/>
        <circle fill="#FFFFFF" cx="158.23" cy="238.98" r="5.27"/>
        <circle fill="#FFFFFF" cx="196.44" cy="238.98" r="5.27"/>
      </svg>
    </div>
    <div class="left-dots-mobile">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136.7 20.01">
        <circle fill="#FFFFFF" cx="5.27" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="43.47" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="81.6" cy="5.27" r="5.27"/>
        <circle fill="#FFFFFF" cx="119.81" cy="5.27" r="5.27"/>
      </svg>
    </div>
    <div class="text-column">
      <div class="top-content">
        <h2 class="h2">Farmers and Ranchers are <span class="subtitle">the&nbsp;Key</span>
        </h2>
      </div>
      <div class="bottom-content">
        <p class="bottom-content-text">But they’ll need our support for greater&nbsp;impact.</p>
      </div>
    </div>
    <div class="right-dots">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201.7 245.01">
        <circle fill="#FEDD00" cx="5.27" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="44.22" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="83.17" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="122.13" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="161.08" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="200.03" r="5.27"/>
        <circle fill="#FEDD00" cx="5.27" cy="238.98" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="238.98" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="238.98" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="238.98" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="238.98" r="5.27"/>
        <circle fill="#FEDD00" cx="196.44" cy="238.98" r="5.27"/>
      </svg>
    </div>
    <div class="right-dots-mobile">
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174.7 20.01">
        <circle fill="#FEDD00" cx="5.27" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="43.47" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="81.6" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="119.81" cy="5.27" r="5.27"/>
        <circle fill="#FEDD00" cx="158.23" cy="5.27" r="5.27"/>
      </svg>
    </div>
    
  </div>
  
  <div class="image-article">
    <img class="image-article-image" src="../../../public/images/img_section1.jpg" alt="Woman at outdoor market holding fresh tomatoes.">
    <div class="copy">
      <h2>
        <span class="h2-large">PUTTING FOOD ON&nbsp;THE&nbsp;TABLE</span>
      </h2>
      <p>About 17% of total global food production is wasted at the retail, food service, and consumer levels. That’s why we’re working with The Global FoodBanking Network® to ensure food that is grown goes to those most in need, rather than to waste. See how our support of food banking in Mexico is helping to end hunger.</p>
      <p><a class="youtube-player-modal article-cta" data-youtubevideoid="LUFAWTyTSJ8" target="_blank" href="https://www.youtube.com/watch?v=LUFAWTyTSJ8">Learn more about The Global FoodBanking Network</a>.</p>
    </div>
  </div>
  
  <div class="image-article" id="image-article2">
    <img class="image-article-image" src="../../../public/images/img_section2.jpg" alt="Man standing in front of John Deere tractor">
    <div class="copy">
      <h2>
        <span class="h2-large">GOOD WORK FOR A&nbsp;GOOD&nbsp;CAUSE</span>
      </h2>
      <p>When we deliver food to the most needy, we honor the hard work of farmers, like Matt and Kristin Dutton, and give dignity to those experiencing hunger. The Duttons are dedicated supporters of River Bend Food Bank, which collects and distributes food to families and youth in their community who might otherwise go hungry. In 2021, the John Deere Foundation pledged $2.7M to food-banking systems around the world, supporting the distribution of 12.8M&nbsp;meals.</p>
        <p><a class="youtube-player-modal article-cta" data-youtubevideoid="SRGdRFLX-rQ" target="_blank" href="https://www.youtube.com/watch?v=SRGdRFLX-rQ">Learn more about the River Bend Food&nbsp;Bank</a>.</p>
    </div>
  </div>
  
  <div class="image-article">
    <img class="image-article-image" src="../../../public/images/img_section3.jpg" alt="Man harvesting crops in an African field">
    <div class="copy">
      <h2>
        <span class="h2-large">TRAINING FARMERS IN&nbsp;AFRICA</span>
      </h2>
      <p>In 2019, we awarded $5M to One Acre Fund to provide millions of smallholder farm farmers in Africa with resources and support fundamental to their prosperity. One Acre Fund “puts farmers first,” and together we envision a world in which all farmers can feed themselves, their families, and their communities.</p>
      <p><a class="article-cta" target="_blank" href="https://oneacrefund.org/">Learn more about One Acre&nbsp;Fund</a>.</p>
    </div>
  </div>
  
  <div class="image-article" id="image-article4">
    <img class="image-article-image" src="../../../public/images/img_section4.jpg" alt="John Deere volunteer handing a box of supplies to a woman">
    <div class="copy">
      <h2>
        <span class="h2-large">OUR PEOPLE ARE&nbsp;STEPPING&nbsp;UP</span>
      </h2>
      <p>Being a good neighbor is part of our culture and with over 75,000 employees around the world, there’s no limit to what our people can accomplish. Through 124,000 hours of volunteerism in 2021, our people created more than $3M in value through their service in our communities, often in the vital work of food&nbsp;banks.</p>
    </div>
  </div>
  
  <div class="image-article">
    <img class="image-article-image" src="../../../public/images/img_section5.jpg" alt="Farmer standing on a John Deere machine">
    <div class="copy">
      <h2>
        <span class="h2-large">SERVING STEWARDS OF&nbsp;THE&nbsp;LAND</span>
      </h2>
      <p>Supporting farmers is what we do, in good times and bad. We host benefit concerts with Farm Rescue, a non-profit that supports farmers in need. But that’s not all. We also partner with the National Black Growers Council and the Thurgood Marshall College Fund to establish the LEAP Coalition, which eliminates barriers created by Heirs Property and provides resources to advance the livelihoods of Black&nbsp;farmers.</p>
      <p><a class="article-cta" target="_blank" href="https://www.deere.com/en/stories/featured/leap/">Learn more about LEAP Coalition</a>.</p>
    </div>
  </div>
  
  <hero-block
    hero2heading1="WE’LL WORK UNTIL THE JOB IS DONE"
    hero2heading3="We’re committed to creating a better world for all. See how we’re helping people and communities all over the world."
    hero2imgurl="../../../public/images/img_bottom_section_background.jpg"
    hero2imgurlmobile="../../../public/images/img_bottom_section_background_mobile.jpg"
    hero2imgurltablet="../../../public/images/img_bottom_section_background_tablet.jpg"
    cta="LEARN MORE"
    ctaurl="https://www.deere.com/en/our-company/sustainability/citizenship/"
  />
  
  <youtube-player-modal></youtube-player-modal>
  
  <script type="ts">
    import {RiotComponentExport} from 'riot';

    import HeroBlock from '../../ui-component/hero-block/hero-block.riot';

    import JdButton from '../../ui-component/buttons/jd-button.riot';
    
    import YoutubePlayerModal from '../../ui-component/modals/youtube-player-modal.riot';

    interface Props {
      path: string;
    }

    interface State {
      currentViewPort: string;
      show: number;
      rebuild: boolean;
      cta: string;
      ctaUrl: string;
      version: string;
    }

    interface FoodInsecurity extends RiotComponentExport<Props, State> {
      state: State;
    }

    function build(): FoodInsecurity {
      return {
        state: {
          currentViewPort: 'desktop',
          show: 1,
          rebuild: false,
          cta: '',
          ctaUrl: '',
          version: '',
        },

        onMounted(): void {
          this.setListeners();
        },

        onBeforeUnmount(): void {
          this.removeListeners();
        },

        setListeners(): void {
          window.addEventListener('resize', this.onResize, false);
        },

        removeListeners(): void {
          window.removeEventListener('resize', this.onResize, false);
        },

        onResize(): void {
          let sT: number = 0;
          window.clearTimeout(sT);
          this.update({
            rebuild: true
          });
          sT = window.setTimeout(() => {
            this.update({
              rebuild: false
            });
            window.clearTimeout(sT);
          }, 200);
        }
      };
    }

    build.components = {
      HeroBlock,
      JdButton,
      YoutubePlayerModal
    };

    export default build;
  </script>

  <style type="scss">
    @use './src/client/sass/abstracts/colors';
    @use './src/client/sass/abstracts/fonts';
    @use './src/client/sass/abstracts/respond';

    $slideSpacing: 0.5rem;

    :host {
      position: relative;
      display: block;
      margin-left: auto;
      margin-right: auto;
      font-family: 'jd_sans_promedium', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-weight: 500;
      background: #FFFFFF;
      color: #367C2B;

      @include respond.smallscreen-up {
        padding: 0;
      }

      .h2 {
        color: colors.$primary-light;
        letter-spacing: 2px;
        margin: 0;
        @include respond.bigscreen-up {
          font-size: 32px;
          line-height: 39px;
        }

        &-small {
          font-size: 20px;
          line-height: 24px;
        }
      }

      .h3 {
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 2px;
        margin: 0;

        &-small {
          font-size: 14px;
          line-height: 17px;
          text-transform: uppercase;
        }

        @include respond.bigscreen-up {
          font-size: 18px;
          line-height: 22px;

        }
      }
    }

    .share-cta-wrapper {
      background-color: colors.$monochrome-dark;
      width: 100%;
    }

    .share-cta {
      color: colors.$primary-light;
      margin: auto;
      width: 100%;
      padding: 0 8vh;
      height: 250px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      p {
        line-height: 26px;
        font-size: 19px;
        font-weight: 500;
      }

      @include respond.bigscreen-up {
        width: 100%;
        padding: 10vh 30vh;

        p {
          line-height: 32px;
          font-size: 24px;
        }
      }
    }

    .v-divider-block {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      margin: auto auto 60px;
      color: #FFFFFF;
      background-color: #367C2B;
      padding: 0;
      font-size: 1.125rem;
  
      .left-dots-mobile {
        align-self: flex-start;
        display: block;
        width: 136px;
        margin: 25px 12px 0;
      }
  
      .right-dots-mobile {
        align-self: flex-end;
        display: block;
        width: 174px;
        margin: 10px 2px 20px 0;
      }
      
      .left-dots {
        display: none;
      }
      
      .right-dots {
        display: none;
      }
  
      .text-column {
        align-self: center;
        text-align: center;
        .h2 {
          letter-spacing: 0.04rem;
          font-size: 2.25rem;
          line-height: 2.3rem;
        }
        .bottom-content-text {
          font-size: 1.25rem;
        }
      }
      .top-content {
        padding: 0 16px;
        text-transform: uppercase;
    
        .subtitle {
          color: #FFDE00;
          white-space: nowrap;
        }
      }
      .bottom-content {
        padding: 0 16px;
      }

      @include respond.smallscreen-up {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 24px;
  
        .left-dots,
        .right-dots {
          width: 201px;
          flex-shrink: 1;
          height: 100%;
        }
  
        .left-dots {
          align-self: flex-end;
          padding-top: 40px;
          display: block;
          margin-bottom: 7px;
        }
  
        .right-dots {
          margin-top: 10px;
          align-self: flex-start;
          padding-bottom: 40px;
          display: block
        }
  
        .left-dots-mobile {
          display: none;
        }
  
        .right-dots-mobile {
          display: none;
        }
        
        .text-column {
          flex-grow: 2;
          max-width: 860px;
          .h2 {
            font-size: 3rem;
            line-height: 3.1rem;
            letter-spacing: 0.04rem;
          }
          .bottom-content-text {
            font-size: 1.32rem;
          }
          
        }
        .top-content {
          padding: 80px 24px 0;
        }
        .bottom-content {
          padding-bottom: 80px;
        }

      }
      @include respond.mediumscreen-up {
        .top-content {
          padding: 116px 24px 0;
        }
        .bottom-content {
          padding-bottom: 116px;
        }
    
      }

    }

    .image-article {

      color: #000000;
      min-height: 579px;
      position: relative;
      display: flex;
      padding: 0 20px 60px;
      flex-direction: column;
      &:last-of-type {
        padding: 0 20px 60px;
      }

      @include respond.mediumscreen-up {
        align-items: center;
        justify-content: space-between;
        padding: 58px;
        flex-direction: row;
        &:last-of-type {
          padding: 58px 58px 100px;
        }
      }

      .copy {
        display: flex;
        flex-direction: column;
        max-width: none;
        margin: 24px 0 0;
        padding: 0;
        .article-cta {
          color: #367C2B;
        }
        
        @include respond.mediumscreen-up {
          max-width: 45%;
          margin: 24px 0 0;
        }
      }
  
      h2 {
        margin-top: 0;
      }

      & .h2-large {
        font-size: 2rem;
        color: #367C2B;

        @include respond.mediumscreen-up {
          font-size: 2.63rem;
        }

      }

      p {
        font-size: 1.125rem;
        margin-top: 12px;
        @include respond.mediumscreen-up {
          margin-top: 30px;
        }
      }

      & .image-article-image {
        width: 100%;
        display: inline-block;
        position: initial;
        margin: 0;

        @include respond.mediumscreen-up {
          margin: 0;
          display: block;
          max-width: 45%;
        }

      }

      & .image-article-cta {
        margin-top: 1rem;
        max-width: 280px;
      }
    }
    
    #image-article2,
    #image-article4 {
      @include respond.mediumscreen-up {
        flex-direction: row-reverse;
        justify-content: space-between;
        align-content: flex-end;
        .copy {
          margin: 24px 0 0;
        }
      }
    }

    .cta {
      background-image: url('../public/images/Deere_Quote.png');
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 325px;
      color: colors.$secondary-base;
      background-color: colors.$primary-dark;


      .cta-container {
        position: relative;
        display: block;
        padding: 32px;
      }

      .cta-text {
        position: relative;
        display: block;

        .h2 {
          color: colors.$secondary-base;
          font-size: 28px;
          line-height: 30px;
        }

        .p {
          font-family: 'Helvetica Neue', serif;
          font-size: 16px;
          line-height: 26px;
          font-weight: 400;
        }

      }

      .cta-btn-container {
        position: relative;
        display: block;
        gap: 10px;
        margin: auto;
        width: 300px;

      }

      @include respond.bigscreen-up {
        .h2 {
          font-size: 37px;
          line-height: 45px;
        }

        .p {
          font-size: 20px;
          line-height: 24px;
        }

        .cta-btn-container {
          display: inline-flex;
          width: auto;
        }

      }

      @include respond.smallscreen-down {
        background-size: cover;
        background-position: center center;
      }


    }


  </style>
</food-insecurity>

